import { defineMessages } from 'react-intl'

export const createWLANMessages = defineMessages({
  ssidMax: {
    id: 'createWLANMessages.ssidMax',
    description: 'Form error message about maximum characters for Network SSID',
    defaultMessage: 'SSID should be 32 characters max',
  },
  ssidPassMin: {
    id: 'createWLANMessages.ssidPassMin',
    description:
      'Form error message about minimum characters for Network SSID password',
    defaultMessage: 'SSID password should be at least 8 characters long',
  },
  ssidPassMax: {
    id: 'createWLANMessages.ssidPassMax',
    description:
      'Form error message about maximum characters for Network SSID password',
    defaultMessage: 'SSID password should be 64 characters max',
  },
  pskPassMax: {
    id: 'createWLANMessages.pskPassMax',
    description: 'Form error message about maximum characters for Passphrase',
    defaultMessage: 'Passphrase should be 32 characters max',
  },
  pskPassMin: {
    id: 'createWLANMessages.pskPassMin',
    description:
      'Form error message about minimum characters for Network SSID password',
    defaultMessage: 'Passphrase password should be at least 8 characters long',
  },
  requiredFieldPassphrase: {
    id: 'createWLANMessages.requiredFieldPassphrase',
    description:
      'Form error message about maximum characters for Network SSID password',
    defaultMessage:
      'Passphrase is required when enabled with the above checkbox',
  },
})
